// ======================================================================
// File Name       : UserDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../TableHead';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { USER_TYPE, USER_TYPE_LIST } from '../../constants/UserConstants';
import UserAttributeList from './UserAttributeList';
import UserCourseList from './UserCourseList';
import UserRelationList from './UserRelationList';
import { DEFAULT_DATE_FORMAT, DORMANT_STATE_CHANGE_FLAG } from '../../constants/index';

class UserDetail extends React.Component {
  render() {
    const {
      userDetail,
      selectedGroupList,
      groupList,
      managementAuthoritys,
      userAttributes,
      courseList,
      childUserList,
      isCheck,
      userCourseRelation,
      allGroupList,
      showLoginIdPasswordSendFlag,
    } = this.props;
    let groupRelationView = null;
    let groupRelations = [];
    let groupListCheck = groupList;
    if (allGroupList) {
      groupListCheck = allGroupList;
    }
    if (isCheck) {
      groupRelations = selectedGroupList;
    } else if (userDetail.groupRelationList) {
      groupRelations = userDetail.groupRelationList;
    }
    groupRelations = groupRelations && groupRelations.length ?
    groupRelations.filter(v => v.groupSecernId) : null;
    if (groupRelations && groupRelations.length) {
      groupRelationView = groupRelations.map((item, index) =>
      (item.groupSecernId ?
        <Form.Group className="form-info" key={item.groupSecernId}>
          <Col as={Form.Label} sm={3}>
            所属ユーザーグループ {index + 1}
          </Col>
          <Col sm={7} className="padding-top-bottom-10">
            {convertNodeGroupToNodeString(item.groupSecernId, groupListCheck)}
          </Col>
        </Form.Group> : null),
      );
    } else {
      groupRelationView =
        (<Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            所属ユーザーグループ 1
          </Col>
          <Col sm={7} className="padding-top-bottom-10" />
        </Form.Group>);
    }
    const managementAuthority =
      managementAuthoritys.bySecernId[userDetail.managementAuthoritySecernId] || {};
    let dormantState = userDetail.dormantState;
    if (isNaN(parseInt(userDetail.dormantState, 10))) {
      dormantState = 0;
    }
    return (
      <Col sm={12}>
        <Form className='form-horizontal'>
          <Form.Group className="form-info" controlId="formHorizontalUserName">
            <Col as={Form.Label} sm={3}>
              ユーザー名
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {userDetail.userName}&nbsp;
              {parseInt(userDetail.dormantState, 10) === 1 &&
                <span className="">
                  ({getItemBoxName(SELECT_BOX_DATA.DORMANT_STATE, userDetail.dormantState)})
                </span>}
            </Col>
          </Form.Group>
          <Form.Group className="form-info" controlId="formHorizontalLoginID">
            <Col as={Form.Label} sm={3}>
              ログインID
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {userDetail.loginId}
            </Col>
          </Form.Group>

          {groupRelationView}
          <Form.Group className="form-info" controlId="formHorizontalLoginID">
            <Col as={Form.Label} sm={3}>
              メールアドレス
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {userDetail.mailAddress}
            </Col>
          </Form.Group>

          {parseInt(userDetail.userType, 10) === USER_TYPE.GUARDIAN &&
            <UserRelationList childUserList={childUserList} />}
          {/* Step10.1.0 START */}
          {!isCheck && <UserCourseList courseList={courseList} dormantState={dormantState} />}
          {/* Step10.1.0 END */}

          <Form.Group className="form-info" controlId="formHorizontalLoginID">
            <Col as={Form.Label} sm={3}>
              ロック状態
            </Col>
            <Col className="padding-top-bottom-10" sm={7}>
              {!isCheck && getItemBoxName(SELECT_BOX_DATA.LOCK_TYPE, userDetail.lockState)}
              {isCheck && getItemBoxName(SELECT_BOX_DATA.LOCK_TYPE, userDetail.isUnlock ? 0 : 1)}
            </Col>
          </Form.Group>
          {!isNaN(userDetail.userType) &&
            parseInt(userDetail.userType, 10) === USER_TYPE.STUDENT ?
              <Form.Group className="form-info" controlId="formHorizontalLoginID">
                <Col as={Form.Label} sm={3}>
                  稼働状態
                </Col>
                <Col className="padding-top-bottom-10" sm={7}>
                  {getItemBoxName(SELECT_BOX_DATA.DORMANT_STATE, dormantState)}
                </Col>
              </Form.Group> : null}
          {!isNaN(userDetail.userType) &&
            parseInt(userDetail.userType, 10) === USER_TYPE.STUDENT ?
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={12} className="margin-top-7">
                  <Form.Check
                    type='checkbox'
                    className="cursor-default"
                    name="dormantStateChangeFlag"
                    id="confirmDormantStateChangeFlag"
                    disabled
                    checked={userDetail.dormantStateChangeFlag !== DORMANT_STATE_CHANGE_FLAG.DO_NOT_CHANGE}
                    label='指定した日にちに稼動状態を変更する'
                  >
                  </Form.Check>
                </Col>
              </Form.Group> : null}
          {!isNaN(userDetail.userType) &&
            parseInt(userDetail.userType, 10) === USER_TYPE.STUDENT && userDetail.dormantStateChangeFlag !== DORMANT_STATE_CHANGE_FLAG.DO_NOT_CHANGE ?
              <Form.Group className="form-info">
                <Col as={Form.Label} className="padding-left-37" sm={3}>
                  変更日
                </Col>
                <Col className="padding-top-bottom-10" sm={2}>
                  {parseDateForDetail(userDetail.dormantStateChangeDate, DEFAULT_DATE_FORMAT)}
                </Col>
              </Form.Group> : null}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={12}  className="margin-top-7">
              <Form.Check
                className="cursor-default"
                name="password_change_flag"
                id="confirm_password_change_flag"
                disabled
                checked={userDetail.passwordChangeFlag === 1}
                label='次回ログイン時にパスワード変更'
              >
              </Form.Check>
            </Col>
          </Form.Group>
          { showLoginIdPasswordSendFlag &&
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={12} className="margin-top-7">
              <Form.Check
                className="cursor-default"
                name="loginIdPasswordSendFlag"
                id="confirmLoginIdPasswordSendFlag"
                disabled
                checked={userDetail.loginIdPasswordSendFlag === 1}
                label='ログインID、パスワードをメールで送信する'
              >
              </Form.Check>
            </Col>
          </Form.Group>
          }
          <UserAttributeList userAttributes={userAttributes} />
        </Form>
      </Col>
    );
  }
}
export default UserDetail;
